module.exports = function createMemoryCache() {
  const cache = {};
  return {
    get: ({ storageKey }) => cache[storageKey],
    set: ({ storageKey }, value) => {
      cache[storageKey] = value;
    },
  };
};
